/**
 * Purchase Options cards in the Linked products block.
 * Syncs selection with variant-selects and product-info section updates.
 */
(function () {
  function getSelectedOptionValueIds(productInfo) {
    const variantSelects = productInfo.querySelector('variant-selects');
    const purchaseLinked = productInfo.querySelector('[data-purchase-option-linked]');
    const inputs = [];

    if (variantSelects) {
      inputs.push(
        ...variantSelects.querySelectorAll('select option[selected], fieldset input:checked')
      );
    }

    if (purchaseLinked) {
      inputs.push(...purchaseLinked.querySelectorAll('input[type="radio"]:checked'));
    }

    return inputs.map((el) => el.dataset.optionValueId).filter(Boolean);
  }

  function onPurchaseOptionChange(event) {
    const purchaseLinked = event.target.closest('[data-purchase-option-linked]');
    if (!purchaseLinked) return;

    const productInfo = purchaseLinked.closest('product-info');
    if (!productInfo || typeof publish !== 'function' || !PUB_SUB_EVENTS) return;

    publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
      data: {
        event,
        target: event.target,
        selectedOptionValues: getSelectedOptionValueIds(productInfo),
      },
    });
  }

  document.addEventListener('change', (event) => {
    if (
      event.target.matches('input[type="radio"]') &&
      event.target.closest('[data-purchase-option-linked]')
    ) {
      onPurchaseOptionChange(event);
    }
  });
})();
